export default "__VITE_ASSET__BYMenWPp__"